module.exports = __webpack_public_path__ + "img/nodata.e5d264d5.png";